import request from "./request";
import { throttle } from "lodash";

const _getPlans = async (all = false) => {
    const response = await request.get(
        `/payment/plan${all ? "?all=true" : "?all=false"}`
    );
    return response.data as [];
};
export const getPlans = throttle(_getPlans, 60 * 1000, {
    leading: true,
    trailing: false,
});
export const getPlanById = async (id: string) => {
    const plans: any[] | undefined = await getPlans(true);
    if (!plans) return undefined;
    const plan = plans.find((plan: any) => {
        return plan.id === id;
    });
    return plan;
};

export const getPlan = async (
    interval: "year" | "month",
    planFeatures: string,
    isPublic: boolean,
    currency: string
) => {
    const plans: any[] | undefined = await getPlans(!isPublic);
    if (!plans) return undefined;
    const plan = plans.find((plan: any) => {
        return (
            plan.currency === currency &&
            plan.interval === interval &&
            plan.metadata.plan_features === planFeatures &&
            plan.metadata.public === isPublic.toString()
        );
    });
    return plan;
};

export const planDisplayName = (plan: any) => {
    // check plan features and show REFSIX PRO or REFSIX Plus
    if (plan?.metadata?.plan_features === "pro") {
        return "REFSIX PRO";
    } else if (plan?.metadata?.plan_features === "basic") {
        return "REFSIX PLUS";
    } else {
        return plan?.name;
    }
};

export const updatePlan = async (
    interval: "year" | "month",
    type: "basic" | "pro",
    instant: boolean = false
) => {
    const response = await request.post("/payment/stripe/update-subscription", {
        interval,
        type,
        instant,
    });
    return response.data;
};

export const asPlanType: (plan: string) => "pro" | "basic" = (plan) => {
    const _plan = plan?.toLowerCase() || "";
    if (_plan === "pro") return "pro";
    else return "basic";
};
export const getSchedule = async () => {
    const response = await request.get("/payment/stripe/schedule");
    return response.data;
};

export const cancelSubscription = async () => {
    const response = await request.post("/payment/stripe/cancel", {});
    return response.data;
};

export const getInvoice = async () => {
    const response = await request.get(`/payment/stripe/invoice`);
    return response.data;
};

export const reactivateSubscription = async () => {
    const response = await request.post(
        "/payment/stripe/reactive-subscription",
        {}
    );
    return response.data;
};

export const getNextInvoice = async () => {
    const response = await request.get(`/payment/stripe/next-invoice`);
    return response.data;
};

export const applyDiscount = async () => {
    const response = await request.post("/payment/stripe/apply-discount", {});
    return response.data;
};
